module.exports = __webpack_public_path__ + "fonts/materialdesignicons-webfont.9d243c16.woff2";